exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".business-tab[data-v-1906d250]{overflow:hidden auto;height:calc(100% - 200px)}.business-tab-name__checked[data-v-1906d250]{font-family:Ysbth;color:#fff;text-shadow:0 0 18px rgba(255,120,0,.4470588235)}.business-tab-name__uncheck[data-v-1906d250]{font-family:Ysbth;color:#fff;text-shadow:0 0 18px rgba(130,165,255,.4470588235)}.tab-child-list__selected[data-v-1906d250]{font-family:Microsoft YaHei UI;color:#fff;text-shadow:0 0 10px #00f2e5;font-weight:700}.tab-child-list p[data-v-1906d250]{border-bottom:1px solid rgba(175,252,255,.1490196078)}[data-v-1906d250]::-webkit-scrollbar{width:0;height:0}", ""]);

// exports
